// clearLivestreamStatusTimer.js
'use strict';
import getOperationData from '../selector/getOperationData.js';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import { PRESET_PREVIEW, PRESET_SD } from '../resource/liveStreamConstants.js';

/**
 * Clear livestream status timer
 * @kind action
 * @param {streaId} {streamId} - action param.
 * @return {Promise} Action promise.
 */
const clearLivestreamStatusTimer =
  ({ streamId }) =>
  async (dispatch, getState) => {
    if (!streamId) {
      return dispatch({ type: '' });
    }
    const existedPreviewTimerId = getOperationData(
      getState(),
      ['timer', 'livestream', streamId, 'status'],
      PRESET_PREVIEW
    );
    const existedSdTimerId = getOperationData(
      getState(),
      ['timer', 'livestream', streamId, 'status'],
      PRESET_SD
    );
    clearTimeout(existedPreviewTimerId);
    clearTimeout(existedSdTimerId);
    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['timer', 'livestream', streamId, 'status'],
        data: {
          [PRESET_PREVIEW]: null,
          [PRESET_SD]: null,
        },
      },
    });
  };

export default clearLivestreamStatusTimer;
